<template>
	<label class="radio">
		<input type="radio" :value="value" :checked="isChecked"
		       @change="$emit('change', $event.target.value)" v-bind="$attrs" />
		<span class="radiomark"></span>
		{{ label }}
	</label>
</template>

<script>
export default {
	inheritAttrs: false,
	name: "v-radio",
	model: {
		prop: 'modelValue',
		event: 'change'
	},
	props:{
		value:{ type: String, default: undefined },
		modelValue:{ default: "" },
		// value:{
		// 	// type: Object,
		// 	default: ''
		// },
		label:{
			type: String,
			default: ''
		},
	},
	computed:{
		isChecked() {
			return this.modelValue === this.value
		}
	}
}
</script>

<style lang="scss" scoped>
.v-radio {
		display: flex;
		position: relative;
		cursor: pointer;
		font-size: 14px;
		letter-spacing: 0.02em;
		color: #636A7B;
		-webkit-user-select: none;
		-moz-user-select: none;
		-ms-user-select: none;
		user-select: none;

	input {
		position: absolute;
		opacity: 0;
		cursor: pointer;
		height: 0;
		width: 0;
	}

	.radiomark {
		height: 18px;
		width: 18px;
		min-width: 18px;
		background-color: #fff;
		border: 1px solid #C5C7D2;
		border-radius: 100%;
		margin-right: 10px;
		&:after {
			content: "";
			position: absolute;
			display: none;
		}
		&:after {
			top: 4px;
			left: 4px;
			width: 10px;
			height: 10px;
			border-radius: 50%;
			background: #4368E0;
		}
	}

	input:checked~.radiomark {
		border-color: #4368E0;
	}

	input:checked~.radiomark:after {
		display: block;
	}
}
</style>
